// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1e-q";
export var animationRelative = "_1e-p";
export var backdropBlur = "_1e-0";
export var detailLabelCell = "_1e-12";
export var detailTable = "_1e-11";
export var detailValueCell = "_1e-13";
export var docIconBox = "_1e-1d";
export var docIconBoxMd = "_1e-1f";
export var docIconBoxSm = "_1e-1e";
export var docTypeRow = "_1e-16";
export var docTypeRowInner = "_1e-17";
export var dropdownMatchDatePicker = "_1e-3";
export var evidenceCardContent = "_1e-1c";
export var fileUploadSpin = "_1e-j";
export var gorgiasOpenButton = "_1e-15 _1e-d";
export var gorgiasTicketCard = "_1e-14";
export var heroModalFooterButton = "_1e-18";
export var hiddenContainer = "_1e-o";
export var iconPrimary = "_1e-1g";
export var iconQuaternary = "_1e-1i";
export var iconTertiary = "_1e-1h";
export var integrationCard = "_1e-1";
export var integrationLogoBox = "_1e-2";
export var mainColumnSticky = "_1e-1b";
export var maxWidthContainer = "_1e-19";
export var modalContentBody = "_1e-a";
export var modalHeaderImage = "_1e-5";
export var modalImageLabel = "_1e-7";
export var modalImageOverlay = "_1e-6";
export var modalImageSubtitle = "_1e-9";
export var modalImageTitle = "_1e-8";
export var modalImageWrapper = "_1e-4";
export var modalStickyFooter = "_1e-b";
export var removeButton = "_1e-e";
export var sidebarColumn = "_1e-1a";
export var spinner = "_1e-i";
export var timelineLine = "_1e-y";
export var timelineLineBlack = "_1e-10 _1e-y";
export var timelineLineGray = "_1e-z _1e-y";
export var timelineLineHeight = "_1e-x";
export var tlDotActivate = "_1e-u";
export var tlDotActivateAnim = "_1e-t";
export var tlDotHide = "_1e-s";
export var tlDotHideAnim = "_1e-r";
export var tlLineActivate = "_1e-w";
export var tlLineActivateAnim = "_1e-v";
export var uploadHint = "_1e-n";
export var uploadIconBox = "_1e-k";
export var uploadLabel = "_1e-m";
export var uploadText = "_1e-l";
export var uploadZone = "_1e-f";
export var uploadZoneCursorDefault = "_1e-h";
export var uploadZoneCursorPointer = "_1e-g";
export var uploadedFileRow = "_1e-c";
export var viewButton = "_1e-d";